import ApiManager from '../api/crud-manager';
import utils from '../utils';

const getChildrenProperties = parentId => {
  const api = new ApiManager();

  // set parameters
  const parameters = {};
  parameters.items = 9999;
  const parameterLink = utils.buildApiParameters(parameters);

  const url = `/api/v2/page/${parentId}/childproperties${parameterLink}`;
  return (
    api
      .get(url)
      // eslint-disable-next-line no-underscore-dangle
      .then(data => data._embedded.childproperties)
      .catch(error => {
        // eslint-disable-next-line no-console
        console.error('getChildrenProperties request failed', error);
        return null;
      })
  );
};

const uniqArray = array => array.filter((a, b) => array.indexOf(a) === b);

class OverviewPageFilters {
  constructor(options = {}) {
    this.config = {
      module: document.querySelector('[data-module="OverviewPageFilters"]'),
      pageId: document.body.dataset.pageId != null ? document.body.dataset.pageId : null,
      ...options
    };
  }

  renderFilterInputs(jsonData) {
    const { module } = this.config;
    const params = new URLSearchParams(window.location.search);
    const FilterItems = module.querySelectorAll('[data-child-module="FilterItem"]');
    let activeFilters = 0;

    if (FilterItems.length) {
      FilterItems.forEach(element => {
        const filterInput = element.querySelector('[data-child-module="FilterInput"]');
        const filterData = jsonData
          .filter(item => item.name === filterInput.name)
          .map(item => item.value)
          .filter(item => item); // make array of filter values in element

        const sortedfilterData = uniqArray(filterData).sort(); // remove duplicates, sort filterData array

        if (sortedfilterData.length) {
          sortedfilterData.forEach(filterItem => {
            const isSelected = params.get(filterInput.name) === filterItem; // check if parameter is in url to add selected state
            filterInput.options.add(new Option(filterItem, filterItem, isSelected, isSelected)); // create option element for filter select
          });
          activeFilters += 1;

          // set event listner to change filter parameter
          filterInput.addEventListener('change', e => {
            params.set(filterInput.name, e.target.value);
            window.location.search = params.toString();
          });
        } else {
          element.classList.add('hidden');
          element.classList.add('is-error');
        }
      });
    }

    if (activeFilters > 0) {
      module.classList.remove('hidden');
    }
  }

  init() {
    const { module, pageId } = this.config;

    if (!module || !pageId) {
      return;
    }

    getChildrenProperties(pageId).then(jsonData => {
      this.renderFilterInputs(jsonData);
    });
  }
}

export default OverviewPageFilters;
